import * as React from "react";
import {ElementProps} from "src/app/model/ElementProps";
import {ValueType} from "src/app/constant/Enums";

const PlainTextElement = (props: ElementProps) => {
    const valueType = props.element.type;
    const isSingleItem = ValueType.SINGLE_ITEM == valueType;
    let childElements: string[] = [];
    if (ValueType.LIST == valueType) {
        childElements = JSON.parse(props.element.jsonVal);
    }
    return <div className={'plain-text-row'}>
        {isSingleItem && (
            <span data-testid='plain-text-element'>{props.element.jsonVal}</span>
        )}
        {
            !isSingleItem &&
            childElements?.map((childElement, index) => (
                <span data-testid={'plain-text-element' + index}>{childElement}<br/></span>
            ))
        }
    </div>
}

export default PlainTextElement;